import { styled as o } from "@lokalise/styled";
import { value as r, typography as t, spacing as e } from "../../utils/theme/index.js";
const a = o.table`
	table-layout: fixed;
	width: 100%;
	border: none;
	border-spacing: 0;
	border-collapse: collapse;
	font-family: ${r("font.family.default")};
`, b = o.th`
	${t("body.small.strong")}
	text-align: left;
	border: none;
	border-bottom-width: 1px;
	border-bottom-style: solid;
	border-bottom-color: ${r("color.border.light")};
	padding: ${e(2)};
`, n = o.td`
	${t("body.small.default")}
	border: none;
	border-top-width: 1px;
	border-top-style: solid;
	border-top-color: ${r("color.border.default")};
	padding: ${e(2)};
`;
export {
  n as Cell,
  a as Container,
  b as HeaderCell
};
//# sourceMappingURL=styles.js.map
